import { render, staticRenderFns } from "./HmFilterMicroShopGoodsNew.vue?vue&type=template&id=6f02bda4&scoped=true&"
import script from "./HmFilterMicroShopGoodsNew.vue?vue&type=script&lang=js&"
export * from "./HmFilterMicroShopGoodsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f02bda4",
  null
  
)

component.options.__file = "HmFilterMicroShopGoodsNew.vue"
export default component.exports